import React from "react";
import { CreateCardPaymentMethodRequest, CreateIbanPaymentMethodRequest, CreateNonIbanPaymentMethodRequest } from "../../models/MerchantModel";
import { toastService } from "../../services/toastService";
import { userPaymentMethodApiService } from "../../services/api/users/UserPaymentMethodApiService";
import { Dialog } from "primereact/dialog";
import { AddBank } from "../Banking/AddBank";
import { AddNonIBAN } from "../Banking/AddNonIBAN";
import { storageService } from "../../services/StorageService";

interface AddUserPaymentMethodProps {
    onHide: () => void;
    userId: number;
    paymentMethodType: "Bank" | "NonIBAN";
}

interface AddUserPaymentMethodState {
    isSubmitting: boolean;
}

export class AddUserPaymentMethod extends React.Component<AddUserPaymentMethodProps, AddUserPaymentMethodState> {
    constructor(props: AddUserPaymentMethodProps) {
        super(props);

        this.state = {
            isSubmitting: false,
        };
    }

    onSuccess = async (item: CreateCardPaymentMethodRequest | CreateIbanPaymentMethodRequest | CreateNonIbanPaymentMethodRequest) => {
        this.setState({ isSubmitting: true });
        const result = await userPaymentMethodApiService.create(this.props.userId, item);
        this.setState({ isSubmitting: false });

        if (result.success) {
            this.props.onHide();
        } else {
            toastService.error(result.message);
        }
    };

    render() {
        const title = this.props.paymentMethodType === "Bank" ? "Add Bank Account" : "Add Non-IBAN Account";

        return (
            <Dialog header={title} visible={true} style={{ width: "40rem" }} onHide={this.props.onHide}>
                {this.props.paymentMethodType === "Bank" ? (
                    <AddBank
                        isSubmitting={this.state.isSubmitting}
                        selectedMerchantId={Number(storageService.getSelectedMerchantId())}
                        OnSuccess={this.onSuccess}
                    />
                ) : (
                    <AddNonIBAN
                        isSubmitting={this.state.isSubmitting}
                        OnSuccess={this.onSuccess}
                    />
                )}
            </Dialog>
        );
    }
}
